import { render, staticRenderFns } from "./financialRecordCom.vue?vue&type=template&id=83564e04&scoped=true&"
import script from "./financialRecordCom.vue?vue&type=script&lang=js&"
export * from "./financialRecordCom.vue?vue&type=script&lang=js&"
import style0 from "./financialRecordCom.vue?vue&type=style&index=0&id=83564e04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83564e04",
  null
  
)

export default component.exports